import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const shopsApi = createApi({
  reducerPath: 'shops',
  baseQuery: createBaseQueryWithReauth('/shops'),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: builder => ({
    fetchShops: builder.query({
      query: () => '',
      providesTags: ['Shops'],
    }),
    createShop: builder.mutation({
      query: (data) => ({
        url: '/create',
        method: 'POST',
        body: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`, // Якщо токен зберігається в localStorage
        },
        params: {
          name: data.name,        // Передача name через параметри запиту (query params)
          address: data.address,  // Передача address через параметри запиту (query params)
        },
      }),
      invalidatesTags: ['Shops'],
    }),
    deleteShop: builder.mutation({
      query: id => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Shops'],
    }),
  }),
});
export const {
  useFetchShopsQuery,
  useCreateShopMutation,
  useDeleteShopMutation

} = shopsApi;
